// addresses modules
import axios from 'axios';
import moment from 'moment';
import {
  WAREHOUSE_ADDRESS_URL,
  WAREHOUSE_UNIT_PRICE_URL,
  WAREHOUSE_PLACE_ORDER_URL,
  WAREHOUSE_PAYMENT_URL,
  WAREHOUSE_ORDER_HISTORY_URL,
  WAREHOUSE_ORDER_DETAIL_URL,
  WAREHOUSE_TRACK_LOG_URL,
  WAREHOUSE_PRINT_BOL_URL,
} from '../../api/url.js';

// initial state
const state = {
  warehouseAddress: {},
  warehouseProductId: '',
  warehouseUnitPrice: '',
  orderDetail: {},
  orderDetails: [],
  orderTimeFrame: [],
}

// actions
const actions = {
  // fetchAddresses
  async fetchWarehouseAddresses(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: WAREHOUSE_ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config) 
    .then((response) => {
      context.commit('fetchWarehouseAddresses', response.data);
    }, (err) => {
      console.log("fetchWarehouseAddresses error:", err);
    })
  },
  // fetchUnitPrice
  async fetchWarehouseUnitPrice(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: WAREHOUSE_UNIT_PRICE_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config) 
    .then((response) => {
      context.commit('fetchWarehouseUnitPrice', response.data[0]);
    }, (err) => {
      console.log("fetchWarehouseUnitPrice error:", err);
    })
  },
  submit: (context, orderData) => axios({
    url: WAREHOUSE_PLACE_ORDER_URL,
    method: 'POST',
    data: orderData,
    headers: {
      Authorization: `JWT ${localStorage.getItem("token")}`
    }
  }),
  submitPayment(context, orderData) {
    const token = localStorage.getItem('token');
    const config = {
      method: "post",
      url: WAREHOUSE_PAYMENT_URL,
      data: orderData,
      headers: {
        Authorization: `JWT ${token}`
      },
    };
    context.commit('orderLoading');  
    axios(config)
      .then((response) => {
        // SONum and Cashier URL
        // for alipay and wechat, a new tab is opened with their respective QR codes
        if (response.data.CashierUrl) {
          window.open(response.data.CashierUrl, '_blank');
        } 
        if (!response.data.CashierUrl) {
          // context.commit('orderSuccessful', response.data);
          Router.push("/confirmation");
        }
      }, (err) => {
        if (err.response.status === 401) { removeToken(); }
        // context.commit('orderFailed', err.response.data.message);
      }
    );
  },
  // fetch order by timeframe
  fetchOrderByTimeFrame(context,timeFrame) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${WAREHOUSE_ORDER_HISTORY_URL}/${timeFrame}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      let orderWithModifiedDate = response.data.reverse().map(Order => {
        const obj = {
          ...Order,
          OrderDate: moment(Order.OrderDate).format("MM/DD/YY"),
          DispatchDate: moment(Order.DispatchDate).format("MM/DD/YY"),
          FinalPrice: Order.FinalPrice.toFixed(2),
        }
        return obj;
      })
      context.commit('fetchOrderByTimeFrame', orderWithModifiedDate);
    })
    .catch (err => {
      console.log('fetchOrderByTimeFrame', err);
    })
  },
  // fetch order detail
  fetchOrderDetails(context, orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${WAREHOUSE_ORDER_DETAIL_URL}/${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
  },
  // fetch order tracking
  fetchOrderTrackLogs(context, orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${WAREHOUSE_TRACK_LOG_URL}/${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
  },
  printBol(context, orderId) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: `${WAREHOUSE_PRINT_BOL_URL}${orderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
  },
};

// mutations
const mutations = {
  fetchWarehouseAddresses(state, payload) {
    state.warehouseAddress = payload;
  },
  fetchWarehouseUnitPrice(state, payload) {
    state.warehouseProductId = payload.pk;
    state.warehouseUnitPrice = payload.UnitPrice;
  },
  getOrderDetail(state, payload) {
    state.orderDetail = payload;
  },
  getOrderDetailHistory(state, payload) {
    state.orderDetail = payload;
  },
  fetchOrderByTimeFrame(state, payload) {
    state.orderTimeFrame = payload;
  },
}
export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/warehouseOrder.js